exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading{\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background: $body-bg;\n}\n\n", ""]);

// exports
